import { CopyButton } from '@/components/CopyButton'

// 값 한 칸. 오른쪽 귀퉁이의 아이콘이 복사이고, 클립보드가 없으면 아이콘도 없다.
// 줄은 줄바꿈하지 않고 칸 안에서 가로로 밀린다. 줄의 열을 minmax(0,1fr) 로 둬서 칸의 최소 폭이 줄 길이가 되지 않게 한다 —
// flex 로 늘어놓으면 줄의 min-content 가 칸의 최소 폭이 되어, 칸을 담은 auto 트랙이 그 폭까지 늘고 아이콘이 화면 밖으로 나간다.
export function CopyBox({ text, label }: { text: string; label: string }) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-1 rounded-md bg-surface-2 py-1 pr-1 pl-3">
      <pre className="overflow-x-auto py-1 font-mono text-[12px]">{text}</pre>
      <CopyButton text={text} label={label} icon />
    </div>
  )
}
